import { RestrictionCriteriasConfig } from "../core.models";

// Assign values to this enum as those values are also used by the BE
export enum DeviceType {
  Mobile = "mobile",
  Desktop = "desktop",
}

export enum Jurisdication {
  UKGC = "ukgc",
  SGA = "sga",
  MGA = "mga",
  DE = "de",
}

export interface PaymentMethods extends RestrictionCriteriasConfig {
  name: string;
  icon: string;
}

export interface VisitorState {
  deviceType: DeviceType | undefined;
  jurisdication?: Jurisdication;
  currencyCode?: string;
  currencySymbol?: string;
  countryCode?: string;
  paymentMethods?: PaymentMethods[];
  exchangeRates?: string;
}
